"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var collapseStringRemoveRegex = /[^A-Z0-9]/gi;
var collapseString = function (str) {
    if (!str) {
        return str;
    }
    return str.toUpperCase().replace(collapseStringRemoveRegex, '');
};
var fixRegionCode = function (country, rawRegion) {
    if (!country || typeof rawRegion !== 'string') {
        return rawRegion;
    }
    var regions = (index_1.regionsByCountry[country] || {}).regions;
    if (!regions) {
        return rawRegion;
    }
    var rawRegionCollapsed = collapseString(rawRegion);
    var foundRegionItem = regions.find(function (_a) {
        var id = _a.id;
        return collapseString(id) === rawRegionCollapsed;
    }) ||
        regions.find(function (_a) {
            var name = _a.name;
            return collapseString(name) === rawRegionCollapsed;
        });
    if (foundRegionItem) {
        return foundRegionItem.id;
    }
    return rawRegion;
};
exports.default = fixRegionCode;
